<template>
  <dialog-v2
    :show="show"
    :disable-save-btn="disableSaveBtn"
    :title="title"
    max-width="450px"
    @close="closeModal"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="form[phoneOwnerKey]"
            :items="phoneOwners"
            item-value="id"
            item-text="name"
            label="Tipo de teléfono"
            color="black"
          />
        </v-flex>
      </v-layout>
      <template v-if="channelId === 2">
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="form.sms_cs_journey"
              :items="csJourneys"
              item-value="id"
              item-text="name"
              label="Etapa"
              color="black"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model.number="form.sms_check_days"
              label="Cantidad de días en consideración"
              type="number"
              color="black"
              min="1"
              :rules="[greaterThanZeroInputRule]"
              @keypress.45.prevent
            />
          </v-flex>
        </v-layout>
        <v-layout wrap mt-2>
          <v-flex xs12>
            <v-checkbox
              v-model="form.only_contacted_sms"
              :hide-details="true"
              class="sms-config-checkbox"
              label="Sólo números dentro de la configuración"
            />
          </v-flex>
        </v-layout>
      </template>
    </template>
  </dialog-v2>
</template>

<script>
import ChannelMixin from '@/mixins/channels';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  mixins: [
    ChannelMixin,
  ],
  components: {
    DialogV2,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    channelId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      form: {
        sms_cs_journey: null,
        sms_check_days: null,
        only_contacted_sms: false,
        sms_owner_id: null,
        ivr_owner_id: null,
        bot_owner_id: null,
        human_owner_id: null,
        whatsapp_owner_id: null,
      },
      csJourneys: [
        {
          id: 1,
          name: 'Gestionando',
        },
        {
          id: 2,
          name: 'Barrido general',
        },
        {
          id: 3,
          name: 'Barrido exitoso',
        },
        {
          id: 4,
          name: 'Conexión',
        },
        {
          id: 5,
          name: 'Contacto',
        },
        {
          id: 6,
          name: 'Contacto directo',
        },
        {
          id: 7,
          name: 'Compromiso',
        },
      ],
      phoneOwners: [
        {
          id: 1,
          name: 'Titular',
        },
        {
          id: 2,
          name: 'Tercero',
        },
        {
          id: null,
          name: 'Todos los teléfonos',
        },
      ],
    };
  },
  computed: {
    title() {
      return `Configuración de ${this.showNameChannel(this.channelId || 1)}`;
    },
    phoneOwnerKey() {
      return `${this.getChannelField('id', this.channelId, 'channel')}_owner_id`;
    },
    disableSaveBtn() {
      return this.channelId === 2 && this.form.sms_check_days === 0;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    greaterThanZeroInputRule() {
      if (this.form.sms_check_days !== 0) {
        return true;
      }
      return 'La cantidad de días en consideración debe ser mayor a cero';
    },
    save() {
      this.$emit('input', {
        ...this.value,
        ...this.form,
      });
      this.closeModal();
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.form = {
          sms_cs_journey: this.value.sms_cs_journey,
          sms_check_days: this.value.sms_check_days,
          only_contacted_sms: this.value.only_contacted_sms,
          sms_owner_id: this.value.sms_owner_id,
          ivr_owner_id: this.value.ivr_owner_id,
          bot_owner_id: this.value.bot_owner_id,
          human_owner_id: this.value.human_owner_id,
          whatsapp_owner_id: this.value.whatsapp_owner_id,
        };
      }
    },
  },
};
</script>

<style scoped>
.sms-config-checkbox >>> label {
  max-width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/ChannelConfigDialog.vue